<template>
<div>
  <div class="content">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-radio-group v-model="yuyueList" @change="OnChange">
          <div v-for="(item,index) in list" :key="index">
            <div class="appointment-item">
              <van-radio :name="item.billno+','+item.outport">
                <div class="">
                  <div class="appointment-title">
                    <span class="bill-num">单号:{{item.billno}}</span>
                  </div>
                  <div class="appointment-card">
                    <div class="receivecorp">送货单位:{{item.receivecorp}}</div>
                    <div class="goods-name">品名:{{item.goodsname}}</div>
                    <div class="khtdh">客户通知单号:{{item.ownerbillno}}</div>
                    <div class="validdate">有效日期:{{item.validdate}}</div>
                    <div class="limitquantity" v-show="item.quantity?true:false">重量:{{item.quantity}}T</div>
                    <div class="limitquantity" v-show="!item.quantity?true:false">预约数量:{{yuzuoyesl}}T</div>
                    <!-- <div class="outport">发货站台:{{item.outport}}</div> -->
                  </div>
                </div>
              </van-radio>
            </div>
          </div>
          <!--  -->
        </van-radio-group>

      </van-list>
    </van-pull-refresh>
  </div>


  <van-popup v-model="showPicker" round position="bottom">
    <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" :loading="loading" />
  </van-popup>

  <div class="add-yuyue">
    <van-button round block type="info" @click="yuyueGoods" class="addBtn" color="#316892">
      预约
    </van-button>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Dialog,
  Toast
} from 'vant'
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      yuyueList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      vehicleState: "01",
      billnoList: [],
      outportList: [],
      tihuoList: [],
      showPicker: false,
      showField: false,
      columns: [],
      value: '',
      xyState: "00",
      yuzuoyesl:0,
      quantity:0,
      billnoOutportList:[],
    }
  },
  created: function() {
    document.title = "卸货预约";
    this.getBindVehicleState();
    this.getxybyopenid();
    var yuzuoyesl = this.$route.params.number;
    var yyrq = this.$route.params.yyrq;
    this.yuzuoyesl = yuzuoyesl;
    this.yyrq = yyrq;
    if(this.yyrq == "")
    {
      this.$router.push({
        name: 'appointment',
        params: {
          number: this.inputYyNumber,
        }
      })
    }
  },

  methods: {
    OnChange(resData) {
      var billnoOutportList = JSON.stringify(resData);
      this.billnoOutportList = JSON.parse(billnoOutportList);
    },
    //判断是否绑定车辆
    getBindVehicleState() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getBindVehicleState(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.vehicleState = res.data.yhzt;
          if (that.$data.vehicleState == '02') {
            that.$router.push({
              name: 'addAllCar'
            })

          }
        } else if (res.respCode < 0) {
          Toast.fail(res.message);
        } else {
          Toast.fail('连接异常');
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    getYuyueList() {
      var openid = this.$store.state.wx_info.openid;
      var yyrq = this.yyrq;
      var txhlb = "卸货";
      var postData = {
        yyrq:yyrq,
        txhlb:txhlb,
        openid:openid
      };

      var that = this;
      api.gettxhtzdnew(postData).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var dataList = res.data;
          that.$data.list = dataList;
        } else if (res.respCode < 0) {
          Toast.fail(res.message);
        } else {
          Toast.fail('连接异常');
        }

      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    onLoad() {
      console.log(this.$route.params.xhdh);
      console.log(this.$route.params.qfh);
      
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.getYuyueList();

        this.loading = false;
        this.finished = true;
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },

    yuyueGoods() {
      var that = this;
      var dataList = that.$data.list;
      var billnoOutportList = that.$data.billnoOutportList;

      var billnoList = [];
      var outportList = [];
      var tihuoList = [];

      for (var i = 0; i < dataList.length; i++) {
        if (dataList[i]['billno']+','+dataList[i]['outport'] == billnoOutportList ) {
          billnoList.push(dataList[i]['billno']);
          outportList.push(dataList[i]['outport']);
          tihuoList.push(dataList[i]['ownerbillno'] + '[' + dataList[i]['receivecorp'] + '  ' + dataList[i]['goodsname'] + ']')
        }
      }



      var billnoStr = "";
      var outportStr = "";
      var tihuoStr = "";

      //billnoStr = billnoList;
      for (var k = 0; k < billnoList.length; k++) {
        billnoStr += billnoList[k] + ",";
      }
      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (billnoStr.length > 0) {
        billnoStr = billnoStr.substr(0, billnoStr.length - 1);
      }

      for (var l = 0; l < outportList.length; l++) {
        outportStr += outportList[l] + ",";
      }

      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (outportStr.length > 0) {
        outportStr = outportStr.substr(0, outportStr.length - 1);
      }

      for (var m = 0; m < tihuoList.length; m++) {
        tihuoStr += tihuoList[m] + ",";
      }

      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (tihuoStr.length > 0) {
        tihuoStr = tihuoStr.substr(0, tihuoStr.length - 1);
      }

      that.$data.outportStr = outportStr;
      that.$data.billnoStr = billnoStr;

      if(outportStr.length <= 0)
      {
        Toast.fail('请选择您的卸货信息');
        return false;
      }

      //请确认是否提某某客户的什么品种，如以上信息均不是您需要选择的提货，请联系货主确认
      Dialog.confirm({
        message: '请确认是否卸' + tihuoStr + '，如以上信息均不是您需要选择的卸货，请联系货主确认!！',
      }).then(() => {


        var xyState = that.$data.xyState;
        if (xyState == 1) {
          console.log('获取配单信息，outportStr:', outportStr)
          that.getPdInfo(outportStr);
        } else if (xyState == 0) {
          that.$router.push({
            name: 'appointmentxy',
          })
        } else {
          Dialog({
            message: '当前不可预约'
          });
        }

      }).catch(() => {
        // on cancel
        return false;
      });

    },
    getPdInfo(outportStr) {

      var that = this;
      var yyrq = this.yyrq;
      var postData = {
        thk:outportStr,
        yyrq:yyrq
      };
      api.getpdxxnew(postData).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.showField = true;
          that.$data.showPicker = true;

          var dataList = res.data;
          var columns = [];
          for (var i = 0; i < dataList.length; i++) {
            columns.push({
              id: dataList[i]['id'],
              text: '['+ dataList[i]['thk'] + '] '+dataList[i]['pdrq'] + ' ' + dataList[i]['pdsj']
            });
            that.$data.columns = columns;
          }
        } else if (res.respCode < 0) {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });
        } else {
          Dialog.alert({
            message: `${res.message},code:${res.respCode}`,
          }).then(() => {

          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    // TODO 提交预约
    onConfirm(value) {
      this.showPicker = false;
      var id = value.id;
      //var text = value.text;

      var openid = this.$store.state.wx_info.openid;
      var billnos = this.$data.billnoStr;
      //billnos = escape(billnos);
      var that = this;
      if (billnos.length <= 0) {
        Dialog.alert({
            message: '请选择正确的单号',
          })
          .then(() => {

          })
      }
      var yuzuoyesl = that.yuzuoyesl;
      const toast = Toast.loading({ message: '预约提交中...', duration: 0, forbidClick: true });
      api.addYuyue(openid, id, billnos,yuzuoyesl, this.$route.params.xhdh, this.$route.params.qfh).then(function(resData) {
        toast.clear();
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          Dialog.alert({
              message: '预约成功',
            })
            .then(() => {
              // on confirm
              that.$router.push({
                name: 'orderlist'
              });
            })
        } else if (res.respCode < 0) {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });

        }
        else if(res.respCode === "S0001"){
          Dialog.alert({
            title:res.message,
            message:res.data,
          }).then(()=>{
            this.$router.push({
              name: 'steamxy'
            })
          })
        }

        else {
          Dialog.alert({
            message: `appointmentMessage:${res.message+","+res.respCode}`,
          }).then(() => {

          });
        }
      }).catch(function(err) {
        toast.clear();
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    getxybyopenid() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getxybyopenid(openid).then(function(resData) {
        var res = JSON.parse(resData);
        that.$data.xyState = res.data;
      });
    } //

  }
}
</script>

<style lang="scss" scoped>
body,
html {
    overflow-x: hidden;
}

.content {
    margin-top: 1rem;
    .appointment-item {
        background: #ffffff;
        border-radius: 5px;
        position: relative;
        background: #ffffff;
        margin: 0 1rem;
        padding: 1rem 0.875rem;
        color: #101010;
        font-size: 0.875rem;
        line-height: 2;
        margin-bottom: 1rem;
        .receivecorp {
            font-weight: bold;
            color: #3eb4fa;
        }
        .goods-name {
            font-weight: bold;
            color: #3eb4fa;
        }
    }
}

.add-yuyue {
    position: fixed;
    bottom: 3.75rem;
    left: 0.5rem;
    right: 0.5rem;
    line-height: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}
</style>
